module.exports = __webpack_public_path__ + "static/img/guide-map.3d9a8286.jpg";